import React from 'react'
import { useTranslation } from 'react-i18next'
import {
  Input,
  SegmentedControl as MantineSegmentedControl,
  SegmentedControlProps as MantineSegmentedControlProps,
} from '@mantine/core'
import { FormUtils } from '@/utils'

export interface SegmentedControlProps extends MantineSegmentedControlProps {
  label?: React.ReactNode
  fieldRef?: any
  normalize?: (value: string) => string
  translateParams?: object
  meta?: any
}

export const SegmentedControl = ({
  label,
  normalize,
  meta,
  fieldRef,
  translateParams,
  ...props
}: SegmentedControlProps) => {
  const { t } = useTranslation()

  const { error } = meta

  const showError = Boolean(error)

  const getErrorMessage = () => {
    return FormUtils.getErrorMessage(error, {
      t,
      translateParams: translateParams,
    })
  }

  return (
    <Input.Wrapper label={label} error={showError ? getErrorMessage() : null}>
      <div>
        <MantineSegmentedControl {...props} />
      </div>
    </Input.Wrapper>
  )
}
